import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import IconButton from "../../../app/components/IconButton";

import GeneralService from "../../../services/GeneralService";
import { MessageError, MessageSuccess } from "../../../utils/message";
import { cleanData, deleteFromParametrizeDocuments, setSelectedDocument } from "../../../reducers/documents/reducerGenerateDocument";
import confirmDelete from "../../../utils/confirmDelete";
import { isURL, toast } from "../../../utils";
import { TOAST_INFO } from "../../../constant/constant";

const ListDocument = ({ setShow, setShowModalRoles }) => {
    const { filtered } = useSelector(state => state.documentsAutoSlice);
    const { canActionRoles, auth } = useSelector(state => state.loginSlice);
    const dispatch = useDispatch();
    const history = useHistory();

    const deleteDocument = async (id) => {
        const service = new GeneralService("documents-auto");
        const res = await service.delete(id);
        if (res.is_ok) {
            MessageSuccess("El documento ha sido eliminado exitosamente!");
            dispatch(deleteFromParametrizeDocuments({ value: id }));
            return;
        }
        MessageError(res.message, service.status);
    }

    const handleGenerateDocument = (document) => {
        if (!isURL(document.url_template_html)) {
            return toast(dispatch, "Documento no parametrizado", TOAST_INFO);
        }

        history.push(`/documents-auto/generate/${document.id}`)
    }

    return (
        <>
            <div className="order">
                {
                    filtered.length === 0 ?
                        <div className="alert alert-warning text-center mt-2" role="alert">
                            No hay documentos que mostrar
                        </div>
                        :
                        <div className="divxscroll d-block rounded-3 clip-hide">
                            <table className={`table table-responsive table-header-custom animate__animated animate__fadeIn ${filtered.length > 0 && "table-striped"}`}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>Descripción</th>
                                        <th>Acciones</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filtered.map((item, i) => (
                                            <tr key={item.id}>
                                                <td></td>
                                                <td style={{ width: "40px" }}>{i + 1}.</td>
                                                <td style={{ maxWidth: "300px" }}>{item.name}</td>
                                                <td style={{ maxWidth: "400px" }}>{item.description}</td>
                                                <td>
                                                    {
                                                        canActionRoles
                                                        &&
                                                        <IconButton
                                                            icon="fa-solid fa-key text-green"
                                                            title="Roles"
                                                            onClick={() => {
                                                                dispatch(setSelectedDocument({ value: item }));
                                                                setShowModalRoles(true)
                                                            }}
                                                        />
                                                    }
                                                    <IconButton
                                                        icon="fa-solid fa-pen-to-square text-green"
                                                        title="Editar documento"
                                                        onClick={() => {
                                                            dispatch(cleanData());
                                                            dispatch(setSelectedDocument({ value: item }));
                                                            setShow(true);
                                                        }}
                                                    />
                                                    <IconButton
                                                        icon="fa-solid fa-gear text-green"
                                                        title="Parametrizar documento"
                                                        onClick={() => history.push(`/documents-auto/parameterization/${item.id}`)}
                                                    />
                                                    <IconButton
                                                        icon="fa-solid fa-print text-green"
                                                        title="Generar documento"
                                                        onClick={() => handleGenerateDocument(item)}
                                                    />
                                                    <IconButton
                                                        icon="fa-solid fa-trash-can text-red"
                                                        title="Eliminar documento"
                                                        onClick={async () => await confirmDelete(() => deleteDocument(item.id))}
                                                    />
                                                </td>
                                                <td></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                }
            </div>
        </>
    );


}

export default ListDocument;